import { Controller } from 'front-end-core/core/Router'
import getUrl from 'front-end-core/core/url'
import config from 'constants/aol/config'
import { DASHBOARD } from 'constants/controllers'
import { GARedirect } from 'helpers/redirects'
import Main from 'pages/dashboard/ConnectedDashboard'

const validRoutes = config.reduce((acc, curr) => curr.urlFragment.length > 0 ? [...acc, curr.urlFragment] : acc, [])

export default new Controller({
  name: DASHBOARD,
  route: ':aol',
  controller (Router, { params: { aol }, queryString, query }, render) {
    if (!validRoutes.some(route => route === aol)) {
      return
    }

    if (GARedirect(queryString)) {
      return
    }

    const pageId = getUrl(DASHBOARD, { aol })

    render(
      { Main },
      { aol, query },
      {
        searchType: 'qa',
        pageId,
        className: 'dashboard',
        name: DASHBOARD,
        aol
      }
    )

    return pageId
  }
})
